export class Research {
  public carouselItems: Array<{ title: string; categories: Array<string>, active?: boolean }> = [
    {
      title: 'Exploratory Research',
      categories: [],
      active: true
    }, {
      title: 'Descriptive Research',
      categories: []
    }, {
      title: 'Explanatory Research',
      categories: []
    }, {
      title: 'Campaign Pretesting',
      categories: [
        'Free-association tests',
        'Qualitative interviews',
        'Statement comparison tests',
        'Comprehension tests',
        'Reaction tests',
        'Folder tests'
      ]
    }, {
      title: 'Campaign post-testing',
      categories: [
        'Recall tests',
        'Sales tests',
        'Attitude tests',
        'Expenditure vs effect evaluations'
      ]
    }
  ];
}
